import React from "react";

const SkeletonSection = () => (
  <div className="flex flex-col divide-y bg-white rounded-lg shadow-md">
    <div className="px-4 py-3 text-sm">
      <div className="h-4 w-28 bg-gray-200 rounded-md" />
    </div>
    <div className="px-4 py-3 text-sm space-y-2">
      {[...Array(5)].map((_, index) => (
        <div key={index} className="h-4 bg-gray-200 rounded-md" />
      ))}
    </div>
  </div>
);

const ProductDetailSkeleton = () => {
  return (
    <div className="animate-pulse max-w-4xl grid grid-cols-1 gap-6 lg:max-w-7xl lg:grid-flow-col-dense lg:grid-cols-3">
      <div className="lg:col-start-3 lg:col-span-1">
        <div className="p-4 flex flex-col bg-white rounded-lg text-sm divide-y">
          <div>
            <div className="h-4 w-20 bg-gray-200 rounded-md" />
            <div className="h-4 w-28 bg-gray-200 rounded-md mt-1 mb-2" />
          </div>
          <div className="flex flex-col gap-1">
            <div className="h-4 w-20 bg-gray-200 rounded-md mt-2" />
            <div className="h-4 w-20 bg-gray-200 rounded-md" />
          </div>
          <div className="h-11 bg-gray-300 rounded-md mt-4" />
        </div>
      </div>
      <div className="flex flex-col space-y-6 lg:col-start-1 lg:col-span-2">
        <div className="h-96 bg-gray-300 rounded-lg" />
        <SkeletonSection />
        <SkeletonSection />
      </div>
    </div>
  );
};

export default ProductDetailSkeleton;
